module.exports = __webpack_public_path__ + "public/images/slider/peremutov.21689bcd5cc8eb5059e94ed2f6db6423.png";